// extracted by mini-css-extract-plugin
module.exports = {"label":"ServicesServiceList_label__Q_sLZ","columns":"ServicesServiceList_columns__J7EXV","search-fade-in":"ServicesServiceList_search-fade-in__fCAl_"};